module.exports = __webpack_public_path__ + "a8cd51ca5b52822f67aeee81b1f139dc.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/image/GameOut/affinity/ComTshirtsite02.png
// module id = 555
// module chunks = 0